import { CommonApiUrl } from "@/shared/common/enums";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const commonApi = createApi({
  reducerPath: "commonApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getStopToolUrl: builder.query<string, void>({
      query: () => ({
        url: CommonApiUrl.StopToolUrl,
      }),
    }),
  }),
});

export const { useLazyGetStopToolUrlQuery } = commonApi;
